module.exports = __webpack_public_path__ + "img/ide-property.59a7ae29.svg";